export default __webpack_public_path__ + "static/media/zip.7b576053.svg";